import React from 'react';
import PropTypes from 'prop-types';
import { Seq } from 'immutable';
import get from 'lodash/get';

import Brand from 'models/brand';
import TrackingProperties from 'models/tracking-properties';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  bookings: PropTypes.instanceOf(Seq.Keyed),
  trackingProperties: PropTypes.instanceOf(TrackingProperties).isRequired,
};

const defaultProps = {
  bookings: Seq.Keyed(),
};

const ReceiptButtonsAppButton = ({ authorizationCode, bookings, brand, trackingProperties }) => {
  const booking = bookings.first();

  if (get(booking, 'isMonthly', true) || !brand.showAppDownloadInformation) {
    return null;
  }

  const deepLink = booking.getDeepLink(
    brand,
    {
      c: 'thank_you_page',
      pid: 'thank_you_view_pass',
    },
    false,
    { trackingProperties },
    authorizationCode,
  ).url

  return (
    <div className="col-md-12 col-xs-10 col-xs-push-1 visible-lte-sm">
      <a
        className="btn-alternate btn-block"
        href={deepLink}
      >
        GET PASS IN APP
      </a>
    </div>
  );
};

ReceiptButtonsAppButton.propTypes = propTypes;
ReceiptButtonsAppButton.defaultProps = defaultProps;
export default ReceiptButtonsAppButton;
